export function getPagination(totalPages, currentPage, maxVisible = 4) {
  const pages = [];
  if (totalPages <= maxVisible) {
    // Hiện hết nếu số trang <= 4
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  }

  // 1. Gần đầu: Hiện 4 trang đầu và ... cuối
  if (currentPage <= maxVisible - 1) {
    for (let i = 1; i <= maxVisible; i++) {
      pages.push(i);
    }
    pages.push("...");
    return pages;
  }

  // 2. Gần cuối: Hiện ... đầu và 4 trang cuối
  if (currentPage >= totalPages - (maxVisible - 2)) {
    pages.push("...");
    for (let i = totalPages - maxVisible + 1; i <= totalPages; i++) {
      pages.push(i);
    }
    return pages;
  }

  // 3. Ở giữa: Hiện ... đầu, 3 trang giữa, ... cuối
  pages.push("...");
  pages.push(currentPage - 1);
  pages.push(currentPage);
  pages.push(currentPage + 1);
  pages.push("...");
  return pages;
}
